<div class="text-area--wrapper">
  <nx-formfield nxFloatLabel="auto" [formGroup]="formGroup">
    <nx-formfield-label
      >{{ field.label | translate }}

      <span *ngIf="field.required">*</span>
    </nx-formfield-label>
    <textarea
      nxInput
      cdkTextareaAutosize
      [placeholder]="field.placeholder ?? '' | translate"
      [attr.required]="field.required ?? false"
      [formControlName]="field.name"
    ></textarea>
    <span nxFormfieldHint *ngIf="field.maxLength">
      {{ formGroup.controls[field.name].value?.length ?? 0 }} /
      {{ field.maxLength }}
    </span>
    <nx-error nxFormfieldError *ngFor="let item of formGroup.controls[field.name].errors || {} | arrayKeys">
      {{ (field.customErrorLabel && field.customErrorLabel[item] ? field.customErrorLabel[item] : 'azForm.errors.' + item) | translate }}
    </nx-error>
  </nx-formfield>
</div>
